webpackJsonp([1],{

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(179);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#1bd980',
    secondary: '#b0bec5',
    tertiary: '#ffdd00'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Administration__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Administration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Administration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DBManagement__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DBManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DBManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Moderation__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Moderation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Moderation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Aide__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Aide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Aide__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'Hello',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
}, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a, props: true }, { path: '/apropos', component: __WEBPACK_IMPORTED_MODULE_7__components_Aide___default.a }];

if (false) {
  routes.push({ path: '/administration', component: Administration });
  routes.push({ path: '/dbmanagement', component: DBManagement });
  routes.push({ path: '/moderation', component: Moderation });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Initialize Firebase
var config = {
  apiKey: 'AIzaSyCQex4JKbyUpZHggelHR9INIIAiMetm6DQ',
  authDomain: 'aires-de-jeux-e8525.firebaseapp.com',
  databaseURL: 'https://aires-de-jeux-e8525.firebaseio.com',
  projectId: 'aires-de-jeux-e8525',
  storageBucket: 'aires-de-jeux-e8525.appspot.com',
  messagingSenderId: '105193380802'
};
if (!__WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].apps.length) {
  __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].initializeApp(config);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawer: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Se connecter / créer un compte'
      }],
      title: 'PARC-ÉPIQUE',
      connected: false,
      displayName: '',
      uid: '',
      snackbar: false,
      welcomeDialog: !(localStorage.getItem('dontShowAnyMore') === 'true'),
      dontShowAnyMore: localStorage.getItem('dontShowAnyMore') === 'true',
      mapStyle: 'map',
      maps: { map: 'https://api.mapbox.com/styles/v1/istopopoki/cj9ydd0jg7it52sp7pubunya6/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaXN0b3BvcG9raSIsImEiOiJjaW12eWw2ZHMwMGFxdzVtMWZ5NHcwOHJ4In0.VvZvyvK0UaxbFiAtak7aVw',
        satelite: 'https://api.mapbox.com/styles/v1/istopopoki/ckh2i36iv11yk19rst0zr9vy7/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaXN0b3BvcG9raSIsImEiOiJjaW12eWw2ZHMwMGFxdzVtMWZ5NHcwOHJ4In0.VvZvyvK0UaxbFiAtak7aVw' }
    };
  },

  watch: {
    dontShowAnyMore: function dontShowAnyMore() {
      localStorage.setItem('dontShowAnyMore', this.dontShowAnyMore);
    }
  },
  methods: {
    home: function home() {
      this.$router.push('/');
    },
    checkConnection: function checkConnection() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.connected = !user.isAnonymous;
          vm.displayName = user.isAnonymous ? 'Utilisateur anonyme' : user.displayName;
          vm.uid = user.uid;
          vm.snackbar = !user.isAnonymous;
        } else {
          vm.connected = false;
          vm.displayName = '';
          vm.uid = '';
        }
      }, function (error) {
        console.log(error);
      });
    },
    signout: function signout() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().signOut().then(function () {
        vm.displayName = '';
        vm.connected = false;
      });
    }
  },
  mounted: function mounted() {
    this.checkConnection();
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {},
  computed: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geofire__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geofire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_geofire__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      copyingAreas: false,
      snackbar: false,
      snackbarMsg: '',
      snackbarColor: ''
    };
  },

  computed: {},
  watch: {},
  methods: {
    showSnackbar: function showSnackbar(msg, color) {
      this.snackbarMsg = msg;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    downloadDB: function downloadDB() {
      var vm = this;
      function download(text, name, type) {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        var file = new Blob([text], { type: type });
        var url = URL.createObjectURL(file);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      var db = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/');
      db.once('value', function (snapshot) {
        var data = snapshot.val();
        download(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data), 'airesdejeux_bkp_' + Date.now() + '.json', 'text/plain');
      }).then(function () {
        vm.showSnackbar('succès du téléchargement de la base', 'success');
      }).then(function (reason) {
        vm.showSnackbar('echec du téléchargement de la base : ' + reason, 'error');
      });
    },
    copyComments: function copyComments() {
      var vm = this;
      var comments = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/comments/');
      comments.once('value', function (snapshot) {
        var c = snapshot.val();
        for (var area in c) {
          var users = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(c[area]);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var user = _step.value;

              var newuid = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/' + area + '/uid_comments').push();
              newuid.set(user);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          vm.showSnackbar('Tous les commentaires ont été copiés dans les aires.', 'success');
        }
      });
    },
    copyAires: function copyAires() {
      var vm = this;
      var areas = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires/');
      areas.once('value', function (snapshot) {
        vm.copyingAreas = true;
        var areasList = snapshot.val();
        for (var area in areasList) {
          __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/' + area).set(areasList[area]).then(function (value) {
            // console.log('Nouvelle rentrée avec succès')
          }, function (reason) {
            vm.showSnackbar("Une aire n'a pas pu être copiée", 'error');
          });
        }
        vm.showSnackbar('Fin de la copie des aires', 'success');
        vm.copyingAreas = false;
      });
    },
    DeleteAreasEnriched: function DeleteAreasEnriched() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/').set({}).then(function (value) {
        vm.showSnackbar('Toutes les aires enrichies sont supprimées', 'success');
      }, function (reason) {
        vm.showSnackbar('Echec suppression des aires enrichies', 'error');
        console.log(reason);
      });
    },
    geoFireInitialize: function geoFireInitialize() {
      // GeoFire initialisation
      var firebaseRef = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('geofire');
      var geofire = new __WEBPACK_IMPORTED_MODULE_4_geofire___default.a(firebaseRef);
      var aires = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('aires');
      aires.once('value', function (snapshot) {
        var val = snapshot.val();

        var _loop = function _loop(a) {
          var aire = val[a];
          geofire.set(a, [aire.lat, aire.lon]).then(function () {
            console.log(a + ' initially set to [' + [aire.lat, aire.lon] + ']');
          });
        };

        for (var a in val) {
          _loop(a);
        }
      });
    }
  },
  mounted: function mounted() {
    // Initialize Firebase
    var config = {
      apiKey: 'AIzaSyCQex4JKbyUpZHggelHR9INIIAiMetm6DQ',
      authDomain: 'aires-de-jeux-e8525.firebaseapp.com',
      databaseURL: 'https://aires-de-jeux-e8525.firebaseio.com',
      projectId: 'aires-de-jeux-e8525',
      storageBucket: 'aires-de-jeux-e8525.appspot.com',
      messagingSenderId: '105193380802'
    };
    if (!__WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].apps.length) {
      __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].initializeApp(config);
    }
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      equipments: [],
      openAtNight: 'undefined',
      freeArea: 'undefined',
      deleteArea: false,
      deleteReason: '',
      equipmentsDict: ['bac à sable', 'circuit de voitures', 'cheval à bascule', 'escalade', 'fontaine', 'pont de singe', 'table de ping-pong', 'terrain de foot', 'terrain de basket', 'terrain de pétanque', 'toboggan', 'toilettes']
    };
  },

  watch: {
    openAtNightP: function openAtNightP() {
      this.openAtNight = this.openAtNightP === undefined ? 'undefined' : this.openAtNightP.toString();
    },
    freeAreaP: function freeAreaP() {
      this.freeArea = this.freeAreaP === undefined ? 'undefined' : this.freeAreaP.toString();
    },
    equipmentsList: function equipmentsList() {
      this.equipments = this.equipmentsList.slice();
    },
    dialogEditArea: function dialogEditArea() {
      if (!this.dialogEditArea) {
        this.deleteArea = false;
        this.deleteReason = '';
      }
    }
  },
  props: ['dialogEditArea', 'equipmentsList', 'uid', 'areaId', 'openAtNightP', 'freeAreaP', 'connected'],
  methods: {
    authenticateAndCallback: function authenticateAndCallback(callback) {
      var vm = this;
      var currentUser = __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().currentUser;
      if (currentUser) {
        callback().then(function () {
          if (currentUser.isAnonymous) {
            vm.$emit('askForSignInMsg');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth().signInAnonymously().catch(function (error) {
          console.log(error.code);
          console.log(error.message);
        }).then(function (userInfo) {
          vm.uid = userInfo.uid;
          vm.displayName = 'utilisateur mystère';
          callback().then(function () {
            vm.$emit('askForSignInMsg');
          });
        });
      }
    },
    saveAreaInfos: function saveAreaInfos() {
      var vm = this;
      if (this.deleteArea) {
        return __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].database().ref('/aires_suppression/' + vm.areaId).set({
          raison: this.deleteReason,
          uid: this.uid,
          timestamp: Date.now()
        }).then(function () {
          vm.$emit('editSuccess');
        });
      } else {
        var infos = {
          equipements: this.equipments,
          uid: this.uid,
          timestamp: Date.now()
        };
        if (this.openAtNight !== 'undefined') {
          infos.ouvertNuit = this.openAtNight === 'true';
        }
        if (this.freeArea !== 'undefined') {
          infos.gratuit = this.freeArea === 'true';
        }
        var areaInfos = __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].database().ref('/aires_infos/' + vm.areaId).push();
        return areaInfos.set(infos).then(function () {
          vm.$emit('editSuccess');
        });
      }
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_compat_database__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_compat_storage__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_star_rating__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geofire__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geofire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_geofire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EditArea__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EditArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_EditArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__turf_circle__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__turf_mask__ = __webpack_require__(178);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function markerStyle(borderColor, fillColor) {
  return 'background-color: ' + fillColor + ';\n  width: 2rem;\n  height: 2rem;\n  display: block;\n  left: -1rem;\n  top: -1rem;\n  position: relative;\n  border-radius: 2rem 2rem 0;\n  transform: rotate(45deg);\n  border: 3px solid ' + borderColor;
}

function getIcon(borderColor, fillColor) {
  return __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.divIcon({
    className: 'my-custom-pin',
    iconAnchor: [0, 16],
    labelAnchor: [-6, 0],
    popupAnchor: [0, -36],
    html: '<span style="' + markerStyle(borderColor, fillColor) + '" />'
  });
}

var iconSelected = getIcon('white', 'orange');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: { mapStyle: String },
  data: function data() {
    return {
      map: {},
      tertiary: '',
      sheet: false,
      connected: false,
      averageRatingSurroundings: 0,
      averageRatingEquipment: 0,
      seeMore: false,
      pictures: [],
      areaId: '',
      // showLightBox: false,
      tabs: ['Aire', 'Mon avis'],
      tabActive: null,
      ratingSurroundings: 0,
      ratingEquipment: 0,
      comment: '',
      comments: [],
      equipmentsList: [],
      openAtNight: undefined,
      freeArea: undefined,
      sendingRating: false,
      uid: '',
      displayName: '',
      snackbar: false,
      snackbarMsg: '',
      uploadProgress: {},
      loadingData: false,
      askForSignIn: false,
      dialogEditArea: false,
      dialogAddArea: false,
      dialogAddComment: false,
      dialogConfirmArea: false,
      newAreaLatLng: [],
      marker: {},
      markersRef: {},
      geofire: {},
      position: [],
      areaPosition: [],
      deviceDirection: 0,
      googleMapDirections: '',
      tileLayer: {}
    };
  },

  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_6_vue_star_rating___default.a,
    EditArea: __WEBPACK_IMPORTED_MODULE_8__components_EditArea___default.a
  },
  computed: {
    dist: function dist() {
      if (this.sheet) {
        try {
          var distanceMeters = Math.round(this.map.distance(this.position, this.areaPosition));
          if (distanceMeters < 1000) {
            return distanceMeters + ' m\xE8tres';
          } else {
            var distanceKm = Math.round(distanceMeters / 10) / 100;
            return distanceKm + ' km';
          }
        } catch (error) {
          return 0;
        }
      } else {
        return 0;
      }
    }
  },
  methods: {
    editSuccessActions: function editSuccessActions() {
      this.dialogEditArea = false;
      this.snackbarMsg = "Merci, c'est noté !";
      this.snackbar = true;
    },
    takeAPhoto: function takeAPhoto() {
      document.getElementById('cameraInput').click();
    },
    checkConnection: function checkConnection() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.connected = true;
          if (user.isAnonymous) {
            vm.displayName = 'utilisateur mystère';
          } else {
            vm.displayName = user.displayName;
          }
          vm.uid = user.uid;
        } else {
          vm.connected = false;
          vm.displayName = '';
          vm.uid = '';
        }
      }, function (error) {
        console.log(error);
      });
    },
    average: function average(obj, key) {
      var avg = 0;
      if (obj) {
        var n = 0;
        for (var k in obj) {
          if (obj[k][key]) {
            avg += obj[k][key];
            n++;
          }
        }
        if (n) {
          avg /= n;
        }
      }
      return avg;
    },
    fetchArea: function fetchArea() {
      var vm = this;
      vm.comments = [];
      vm.averageRatingSurroundings = 0;
      vm.averageRatingEquipment = 0;
      vm.equipmentsList = [];
      vm.openAtNight = undefined;
      vm.freeArea = undefined;
      vm.pictures = [];

      // average rating
      var comments = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/comments/' + vm.areaId);
      comments.on('value', function (snapshot) {
        vm.comments = snapshot.val();
        vm.averageRatingSurroundings = vm.average(vm.comments, 'ratingSurroundings');
        vm.averageRatingEquipment = vm.average(vm.comments, 'ratingEquipment');
        vm.tabActive = vm.comments ? vm.tabs[0] : vm.tabs[1];
      });

      vm.googleMapDirections = 'https://www.google.com/maps/dir/?api=1&origin=' + vm.position + '&destination=' + vm.areaPosition + '&travelmode=walking';

      // equipment
      var equipments = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_infos/' + vm.areaId).orderByKey().limitToLast(1);
      equipments.on('value', function (snapshot) {
        var infos = snapshot.val();
        if (infos) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(infos)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var i = _step.value;

              vm.equipmentsList = 'equipements' in infos[i] ? infos[i].equipements.slice() : [];
              vm.openAtNight = infos[i].ouvertNuit;
              vm.freeArea = infos[i].gratuit;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          vm.equipmentsList = [];
          vm.openAtNight = undefined;
          vm.freeArea = undefined;
        }
      });

      // carousel
      var pictures = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/images/' + vm.areaId);
      pictures.on('value', function (snapshot) {
        vm.pictures = [];
        var picturesList = snapshot.val();
        if (picturesList) {
          for (var pic in picturesList) {
            vm.pictures.push({
              src: picturesList[pic].path,
              thumb: picturesList[pic].thumbnail
            });
          }
        }
      });

      // user rating & comment
      var note = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/comments/' + vm.areaId + '/' + vm.uid);
      note.on('value', function (snapshot) {
        if (snapshot.val()) {
          vm.ratingSurroundings = snapshot.val().ratingSurroundings;
          vm.ratingEquipment = snapshot.val().ratingEquipment;
          vm.comment = snapshot.val().comment;
        } else {
          vm.ratingSurroundings = 0;
          vm.ratingEquipment = 0;
          vm.comment = '';
        }
      });

      // upload pictures
      if (this.connected) {
        var fileUpload = document.getElementById('cameraInput');
        fileUpload.onchange = function (evt) {
          if (vm.uid) {
            var firstFile = evt.target.files[0]; // get the first file uploaded
            var ts = Date.now();
            var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].storage().ref('photos/' + vm.areaId + '/' + vm.areaId + '_' + vm.uid + '_' + ts);
            var uploadTask = storageRef.put(firstFile);

            uploadTask.on('state_changed', function (snapshot) {
              vm.$set(vm.uploadProgress, ts, snapshot.bytesTransferred / snapshot.totalBytes * 100);
              // console.log(vm.uploadProgress)
            }, function () {
              vm.snackbarMsg = "Aie ! La photo n'est pas partie :(";
              vm.snackbar = true;
              vm.$set(vm.uploadProgress, ts, 0);
            }, function () {
              vm.snackbarMsg = 'Et une photo de plus !';
              vm.snackbar = true;
              vm.$set(vm.uploadProgress, ts, 0);
            });
          }
        };
      }
    },
    authenticateAndCallback: function authenticateAndCallback(callback) {
      var vm = this;
      var currentUser = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].auth().currentUser;

      var callCB = function callCB() {
        var cb = callback();
        if (cb) {
          cb.then(function () {
            if (currentUser.isAnonymous) {
              vm.askForSignIn = true;
            }
          });
        }
      };

      if (currentUser) {
        callCB();
      } else {
        __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].auth().signInAnonymously().catch(function (error) {
          console.log(error.code);
          console.log(error.message);
        }).then(function (userInfo) {
          vm.uid = userInfo.uid;
          vm.displayName = 'utilisateur mystère';
          callCB();
        });
      }
    },
    sendRating: function sendRating() {
      var vm = this;
      this.sendingRating = true;
      vm.dialogAddComment = false;

      return __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/comments/' + vm.areaId + '/' + vm.uid).update({
        ratingEquipment: vm.ratingEquipment,
        ratingSurroundings: vm.ratingSurroundings,
        comment: vm.comment,
        displayName: vm.displayName,
        timestamp: Date.now()
      }).then(function (value) {
        var newuid = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/' + vm.areaId + '/uid_comments').push();
        newuid.set(vm.uid);

        vm.sendingRating = false;
        vm.snackbarMsg = "C'est dans la boite !";
        vm.snackbar = true;
      }, function (reason) {
        console.log('echec!');
        vm.sendingRating = false;
      });
    },
    getDateFromTimestamp: function getDateFromTimestamp(ts) {
      var date = new Date(ts);
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    },
    addArea: function addArea() {
      var _this = this;

      this.dialogAddArea = false;
      this.marker = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.marker(this.newAreaLatLng, { draggable: true }).on('click', function () {
        _this.marker.bindPopup('').openPopup();
        _this.dialogConfirmArea = true;
      }).addTo(this.map);

      this.marker.bindPopup('Ajustez ma position. Puis cliquez moi dessus.').openPopup();
    },
    deleteArea: function deleteArea() {
      this.dialogConfirmArea = false;
      this.map.removeLayer(this.marker);
      this.snackbarMsg = 'La prochaine fois sera la bonne :)';
      this.snackbar = true;
    },
    pushArea: function pushArea() {
      var vm = this;
      var timestamp = Date.now();
      var name = 'aire-' + timestamp;
      var lat = vm.marker.getLatLng().lat;
      var lng = vm.marker.getLatLng().lng;
      var error = false;

      __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/nouvelle_aire/' + name).set({
        lat: lat,
        lon: lng,
        timestamp: timestamp,
        uid: vm.uid
      }).then(function (value) {
        vm.geofire.set(name, [vm.newAreaLatLng.lat, vm.newAreaLatLng.lng]).then(function () {}, function () {
          error = true;
        });
        __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/' + name).set({
          lat: lat,
          lon: lng
        }).then(function () {}, function () {
          error = true;
        });
      }, function () {
        error = true;
      });

      vm.dialogConfirmArea = false;
      if (!error) {
        vm.marker.removeFrom(vm.map);
        vm.snackbarMsg = 'Houra, une aire de plus !';
      } else {
        vm.snackbarMsg = "Quelque chose n'a pas marché :(";
      }
      vm.snackbar = true;
    }
  },
  watch: {
    areaId: function areaId(newId, oldId) {
      if (oldId) {
        var oldMarker = this.markersRef[oldId].marker;
        var oldIcon = this.markersRef[oldId].icon;
        oldMarker.setIcon(oldIcon);
      }
      this.markersRef[newId].marker.setIcon(iconSelected);
    },
    mapStyle: function mapStyle(_mapStyle) {
      this.tileLayer.removeFrom(this.map);
      this.tileLayer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer(_mapStyle, {
        attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
      }).addTo(this.map);
    }
  },
  mounted: function mounted() {
    var vm = this;
    var map = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.map('map', {
      // renderer: L.canvas()
    });
    var flyToMyPosition = true;

    if (localStorage.getItem('zoom') && localStorage.getItem('lat') && localStorage.getItem('lng')) {
      flyToMyPosition = false;
      map.setView([localStorage.lat, localStorage.lng], localStorage.zoom);
    } else {
      var lat = 48.85;
      var lng = 2.34;
      var zoom = 13;
      map.setView([lat, lng], zoom);
      localStorage.zoom = zoom;
      localStorage.lat = lat;
      localStorage.lng = lng;
    }

    vm.map = map;
    vm.tertiary = this.$vuetify.theme.tertiary;

    vm.tileLayer = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer(vm.mapStyle, {
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
    }).addTo(map);

    var accuracy = 0;
    var cst = 40075016.686 * Math.abs(Math.cos(map.getCenter().lat * 180 / Math.PI));
    var metresPerPixel = cst / Math.pow(2, map.getZoom() + 8);
    var markerPosition = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.circleMarker([], {
      stroke: false,
      color: '#0000ff',
      fillOpacity: 0.5,
      radius: 5
    });
    var markerAccuracy = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.circleMarker([], {
      stroke: false,
      color: '#0000ff',
      fillOpacity: 0.03,
      radius: 0
    });

    var LocationControl = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Control.extend({
      options: {
        position: 'topleft'
      },
      onAdd: function onAdd(map) {
        var container = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
        container.style.backgroundColor = 'white';
        container.innerHTML = '<a style="text-align:center;"><i style="vertical-align:middle;" class="material-icons">my_location</i></a>';
        container.style.cursor = 'pointer';
        container.onclick = function () {
          if (vm.position.length) {
            map.flyTo(vm.position, 15);
          } else {
            flyToMyPosition = true;
            map.locate({ watch: true });
          }
        };
        return container;
      }
    });
    map.addControl(new LocationControl());
    map.locate({ watch: true });

    map.on('zoomend', function () {
      metresPerPixel = cst / Math.pow(2, map.getZoom() + 8);
      if (accuracy < 1000) {
        markerAccuracy.setRadius(accuracy / metresPerPixel).bringToBack();
      }
      localStorage.setItem('zoom', map.getZoom());
    }).on('locationfound', function (evt) {
      vm.position = [evt.latitude, evt.longitude];
      accuracy = evt.accuracy;
      if (accuracy < 1000) {
        markerAccuracy.setRadius(accuracy / metresPerPixel).bringToBack();
      }
      markerAccuracy.setLatLng(vm.position).addTo(map);
      markerPosition.setLatLng(vm.position).addTo(map);
      if (flyToMyPosition) {
        map.flyTo(vm.position, 15);
        flyToMyPosition = false;
      }
    }).on('moveend', function (evt) {
      localStorage.setItem('lat', map.getCenter().lat);
      localStorage.setItem('lng', map.getCenter().lng);
    });

    var markers = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.layerGroup().addTo(map);

    var database = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database();
    var aires = database.ref('aires_enrichies');

    // geofire
    var firebaseRef = __WEBPACK_IMPORTED_MODULE_3_firebase_compat_app__["a" /* default */].database().ref('geofire');
    var geofire = new __WEBPACK_IMPORTED_MODULE_7_geofire___default.a(firebaseRef);
    vm.geofire = geofire;
    var center = map.getCenter();

    // radius for the geoquery, in meters

    var radius = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Browser.mobile ? 3000 : 5000;

    var geoQuery = geofire.query({
      center: [center.lat, center.lng],
      radius: radius / 1000
    });

    function getCircle(center, radius) {
      var c = [center.lng, center.lat];
      var options = { units: 'meters' };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__turf_circle__["a" /* default */])(c, radius, options);
    }
    function getCircleLayer() {
      var options = {
        fillColor: 'black',
        fillOpacity: 0.1,
        stroke: false
      };
      return __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.geoJSON(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__turf_mask__["a" /* default */])(getCircle(center, radius), getCircle(center, 1000000)), options);
    }
    var areaCircle = getCircleLayer().addTo(map);

    map.on('moveend', function () {
      if (map.distance(map.getCenter(), center) > radius * 0.66) {
        center = map.getCenter();
        geoQuery.updateCriteria({
          center: [center.lat, center.lng],
          radius: radius / 1000
        });
        areaCircle.clearLayers();
        areaCircle = getCircleLayer().addTo(map);
      }
    });

    map.on('contextmenu', function (e) {
      if (!map.hasLayer(vm.marker)) {
        vm.dialogAddArea = true;
        vm.newAreaLatLng = e.latlng;
      }
    }).on('click', function () {
      vm.areaId = '';
      vm.sheet = false;
    });

    var icon1 = getIcon('white', this.$vuetify.theme.primary);
    var icon2 = getIcon('#b6c4bd', 'white');

    geoQuery.on('key_entered', function (key, location, distance) {
      // vm.loadingData = true
      aires.child(key).once('value', function (snapshot) {
        var area = snapshot.val();
        if (area) {
          var uidComments = area.uid_comments;
          var icon = uidComments ? icon1 : icon2;
          var marker = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.marker([area.lat, area.lon], {
            icon: icon,
            zIndexOffset: uidComments ? 100 : 0
          }).on('click', function (ev) {
            stop(ev);
            // console.log(key)
            vm.areaId = key;
            vm.sheet = true;
            vm.areaPosition = [area.lat, area.lon];
            vm.fetchArea();
            var areaPoint = map.latLngToLayerPoint(vm.areaPosition, map.getZoom());
            setTimeout(function () {
              var bh = document.getElementsByClassName('v-bottom-sheet v-dialog')[0].clientHeight;
              areaPoint = areaPoint.add([0, bh / 2]);
              var newCenter = map.layerPointToLatLng(areaPoint, map.getZoom());
              map.panTo(newCenter);
            }, 500);
          });
          vm.markersRef[key] = { marker: marker, icon: icon };
          markers.addLayer(marker);
        }
      });
    });

    geoQuery.on('key_exited', function (key, location, distance) {
      if (key in vm.markersRef) {
        markers.removeLayer(vm.markersRef[key].marker);
      }
    });

    vm.checkConnection();
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebaseui_dist_firebaseui_css__);
//
//
//
//
//
//
//
//
//





var uiConfig = {
  signInSuccessUrl: '/',
  // autoUpgradeAnonymousUsers: true,
  signInFlow: 'popup',
  signInOptions: [
  // Leave the lines as is for the providers you want to offer your users.
  __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth.GoogleAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth.FacebookAuthProvider.PROVIDER_ID,
  // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
  // firebase.auth.GithubAuthProvider.PROVIDER_ID,
  __WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth.EmailAuthProvider.PROVIDER_ID
  // firebase.auth.PhoneAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: '<your-tos-url>'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wasMounted: false,
      ui: {}
    };
  },

  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     console.log('j activate!')
  //     vm.$nextTick(function () {
  //       if (!vm.ui) {
  //         console.log('creation ui')
  //         vm.ui = new firebaseui.auth.AuthUI(firebase.auth())
  //         // The start method will wait until the DOM is loaded.
  //         vm.wasMounted = true
  //       }
  //       vm.ui.start('#firebaseui-auth-container', uiConfig)
  //     })
  //   })
  // },
  mounted: function mounted() {
    // console.log('je mount')
    if (__WEBPACK_IMPORTED_MODULE_1_firebaseui__["a" /* auth */].AuthUI.getInstance()) {
      var ui = __WEBPACK_IMPORTED_MODULE_1_firebaseui__["a" /* auth */].AuthUI.getInstance();
      ui.start('#firebaseui-auth-container', uiConfig);
    } else {
      var _ui = new __WEBPACK_IMPORTED_MODULE_1_firebaseui__["a" /* auth */].AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase_compat_app__["a" /* default */].auth());
      _ui.start('#firebaseui-auth-container', uiConfig);
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      snackbar: false,
      snackbarMsg: '',
      snackbarColor: '',
      areaNeedingValidation: {},
      map: {},
      sheet: false
    };
  },

  components: {},
  computed: {},
  watch: {},
  methods: {
    showSnackbar: function showSnackbar(msg, color) {
      this.snackbarMsg = msg;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    showMap: function showMap(area) {
      var vm = this;
      this.sheet = true;
      this.$nextTick(function () {
        vm.map.invalidateSize();
      });
      var areaFB = __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref('/aires_enrichies/' + area);
      areaFB.once('value', function (snapshot) {
        var a = snapshot.val();
        var latlng = { lat: a.lat, lon: a.lon };
        vm.map.setView(latlng, 18);
        __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.popup().setLatLng(latlng).setContent(area).openOn(vm.map);
      });
    },

    // showMap(latlng) {
    //   if ('remove' in this.map) {
    //     this.map.remove()
    //   }
    //   this.map = L.map('mapAdmin', {}).setView(latlng, 15)
    //   L.tileLayer(
    //     'https://api.mapbox.com/styles/v1/istopopoki/cj9ydd0jg7it52sp7pubunya6/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaXN0b3BvcG9raSIsImEiOiJjaW12eWw2ZHMwMGFxdzVtMWZ5NHcwOHJ4In0.VvZvyvK0UaxbFiAtak7aVw',
    //     {
    //       attribution:
    //         'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
    //     }
    //   ).addTo(this.map)
    //   L.marker(latlng).addTo(this.map)
    // },
    lookForNewArea: function lookForNewArea() {
      var vm = this;
      this.newAreas = {};
      this.newAreasN = 0;

      __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref('/nouvelle_aire/').once('value', function (snapshot) {
        var na = snapshot.val();
        for (var area in na) {
          // console.log(area)
          var details = na[area];
          if (!('validated' in details)) {
            vm.$set(vm.newAreas, area, details);
            vm.newAreasN++;
          }
        }
      });
    },

    // validateNewArea() {
    //   let vm = this

    //   firebase
    //     .database()
    //     .ref('/nouvelle_aire/' + vm.newArea)
    //     .update({ validated: true })
    //     .then(function() {
    //       vm.snackbarColor = 'green'
    //       vm.snackbarMsg = 'nouvelle aire validée'
    //       vm.snackbar = true
    //     })
    // },
    // RejectNewArea() {
    //   let vm = this
    //   firebase
    //     .database()
    //     .ref('/nouvelle_aire/' + vm.newArea)
    //     .remove()
    //     .then(function() {
    //       firebase
    //         .database()
    //         .ref('/aires_enrichies/' + vm.newArea)
    //         .remove()
    //       vm.snackbarColor = 'red'
    //       vm.snackbarMsg = 'nouvelle aire rejetée'
    //       vm.snackbar = true
    //     })
    // },
    validate: function validate(validationPath) {
      var vm = this;
      var path = '/';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(validationPath), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          path += item + '/';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref(path).update({ validated: true }).then(function () {
        vm.showSnackbar('contribution validée', 'success');
      });
      vm.lookForNewActivity();
    },
    reject: function reject(rejectPath) {
      var vm = this;
      var path = '/';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(rejectPath), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          path += item + '/';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref(path).remove().then(function () {
        vm.showSnackbar('contribution rejetée', 'error');
      });
      vm.lookForNewActivity();
    },
    lookForNewActivity: function lookForNewActivity() {
      var vm = this;
      vm.areaNeedingValidation = {
        headers: [{ text: 'Aire', value: 'area' }, { text: 'Activité', value: 'activity' }, { text: 'timestamp', value: 'timestamp', width: '1%' }, { text: 'date', value: 'date' }, { text: 'Utilisateur', value: 'user' }, { text: 'commentaire', value: 'comment', width: '70%' }, { text: 'Note Equipement', value: 'equipementRating' }, { text: 'Note Cadre', value: 'surroundingsRating' }, { text: 'Equipement', value: 'equipmentList' },
        // {text: 'Photos', value: 'Pictures'},
        { text: 'Modération', value: 'validationPath' }],
        list: []

        // get comments
      };var comments = __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref('/comments/');
      comments.once('value', function (snapshot) {
        var c = snapshot.val();
        for (var area in c) {
          var users = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(c[area]);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(users), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var user = _step3.value;

              if (!('validated' in c[area][user])) {
                var contenu = c[area][user];
                vm.areaNeedingValidation.list.push({
                  value: false,
                  area: area,
                  timestamp: contenu.timestamp,
                  date: new Date(contenu.timestamp).toUTCString(),
                  user: contenu.displayName,
                  comment: contenu.comment,
                  equipementRating: contenu.ratingEquipment,
                  surroundingsRating: contenu.ratingSurroundings,
                  activity: 'Commentaire',
                  validationPath: ['comments', area, user]
                });
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      });

      // get aires infos
      var infos = __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].database().ref('/aires_infos/');
      infos.once('value', function (snapshot) {
        var i = snapshot.val();
        for (var area in i) {
          var changes = i[area];
          for (var change in changes) {
            if (!('validated' in changes[change])) {
              vm.areaNeedingValidation.list.push({
                value: false,
                area: area,
                timestamp: i[area][change].timestamp,
                date: new Date(i[area][change].timestamp).toUTCString(),
                user: i[area][change].uid,
                equipmentList: i[area][change].equipements,
                free: i[area][change].gratuit,
                openAtNight: i[area][change].ouvertNuit,
                validationPath: ['aires_infos', area, change],
                activity: 'Equipement'
              });
            }
          }
        }
      });

      // let images = firebase.database().ref('/images/')
      // images
      //   .once('value', function(snapshot) {
      //     let i = snapshot.val()
      //     for (let area in i) {
      //       // console.log(area)
      //       let images = Object.keys(i[area])
      //       for (let image of images) {
      //         // console.log(i[area][image])
      //         if (!('validated' in i[area][image])) {
      //           let areaContent = vm.areaNeedingValidation[area] || {}
      //           areaContent['image ' + image] = { thumbnail: i[area][image].thumbnail }
      //           areaContent['image ' + image].validationPath = ['images', area, image]
      //           vm.$set(vm.areaNeedingValidation, area, areaContent)
      //         }
      //       }
      //     }
      //   })
      //   .then(function() {
      //     for (let area of vm.areasList) {
      //       // console.log(area)
      //       let areaf = firebase.database().ref('/aires_enrichies/' + area)
      //       areaf.once('value', function(snapshot) {
      //         let a = snapshot.val()
      //         // console.log(a)
      //         if (a) {
      //           let areaContent = vm.areaNeedingValidation[area] || {}
      //           areaContent.coordonnees = { lat: a.lat, lon: a.lon }
      //           // console.log(areaContent)
      //           vm.$set(vm.areaNeedingValidation, area, areaContent)
      //         }
      //       })
      //     }
      //   })
    }
  },
  mounted: function mounted() {
    // Initialize Firebase
    var config = {
      apiKey: 'AIzaSyCQex4JKbyUpZHggelHR9INIIAiMetm6DQ',
      authDomain: 'aires-de-jeux-e8525.firebaseapp.com',
      databaseURL: 'https://aires-de-jeux-e8525.firebaseio.com',
      projectId: 'aires-de-jeux-e8525',
      storageBucket: 'aires-de-jeux-e8525.appspot.com',
      messagingSenderId: '105193380802'
    };
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].apps.length) {
      __WEBPACK_IMPORTED_MODULE_2_firebase_compat_app__["a" /* default */].initializeApp(config);
    }
    this.lookForNewActivity();

    this.map = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.map('moderationMap', {});

    __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.tileLayer('https://api.mapbox.com/styles/v1/istopopoki/cj9ydd0jg7it52sp7pubunya6/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaXN0b3BvcG9raSIsImEiOiJjaW12eWw2ZHMwMGFxdzVtMWZ5NHcwOHJ4In0.VvZvyvK0UaxbFiAtak7aVw').addTo(this.map);
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(!_vm.deleteArea) ? _c('div', [_c('div', {
    staticClass: "pt-3 pb-5 text-xs-center"
  }, [_vm._v("\n        On dirait que vous souhaitez aider la communauté à en savoir plus sur cette aire ? Vous êtes au bon endroit.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n        La nuit l'aire est :\n      ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.openAtNight),
      callback: function($$v) {
        _vm.openAtNight = $$v
      },
      expression: "openAtNight"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "ouverte",
      "value": "true"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "fermée",
      "value": "false"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "secondary",
      "label": "on ne sait pas",
      "value": "undefined"
    }
  })], 1), _vm._v("\n      L'aire est :\n      "), _c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.freeArea),
      callback: function($$v) {
        _vm.freeArea = $$v
      },
      expression: "freeArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "gratuite",
      "value": "true"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "payante",
      "value": "false"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "secondary",
      "label": "on ne sait pas",
      "value": "undefined"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Équipement",
      "items": _vm.equipmentsDict,
      "multiple": "",
      "chips": "",
      "color": "primary",
      "hint": "Quels sont les équipements présents ?",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.equipments),
      callback: function($$v) {
        _vm.equipments = $$v
      },
      expression: "equipments"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pt-5",
    attrs: {
      "color": "error",
      "label": "Cette aire devrait être supprimée de la carte"
    },
    model: {
      value: (_vm.deleteArea),
      callback: function($$v) {
        _vm.deleteArea = $$v
      },
      expression: "deleteArea"
    }
  }), _vm._v(" "), (_vm.deleteArea) ? _c('v-textarea', {
    attrs: {
      "color": "error",
      "box": "",
      "label": "Parce que...",
      "hint": "Expliquer en quelques mots pourquoi"
    },
    model: {
      value: (_vm.deleteReason),
      callback: function($$v) {
        _vm.deleteReason = $$v
      },
      expression: "deleteReason"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pt-3 text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.authenticateAndCallback(_vm.saveAreaInfos)
      }
    }
  }, [_vm._v("Enregistrer")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "color": "orange",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('div', {
    attrs: {
      "id": "moderationMap"
    }
  })]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h1', {
    staticClass: "pt-5"
  }, [_vm._v("Activité non validée")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.areaNeedingValidation.headers,
      "items": _vm.areaNeedingValidation.list
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          on: {
            "click": function($event) {
              return _vm.showMap(props.item.area)
            }
          }
        }, [_vm._v(_vm._s(props.item.area))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.activity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.timestamp))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.user))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.comment))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.equipementRating))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.surroundingsRating))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.equipmentList))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          attrs: {
            "color": "success",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.validate(props.item.validationPath)
            }
          }
        }, [_vm._v("V")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "error",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.reject(props.item.validationPath)
            }
          }
        }, [_vm._v("X")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapAdmin"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('h1', {
    staticClass: "pt-5"
  }, [_vm._v("Outils d'administration")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dbmanagement"
    }
  }, [_vm._v("\n          Gestion de la base de données\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderation"
    }
  }, [_vm._v("\n          Modération de l'activité\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "rgb(250,250,250)"
    }
  }, [_c('v-container', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h1', {
    staticClass: "pt-5 pb-3"
  }, [_vm._v("Les enfants ne sont pas beaucoup dehors")]), _vm._v(" "), _c('p', [_vm._v("\n            Avez-vous entendu parler de la campagne \"Dirt is good\" ?\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Une enquête menée auprès de 12 000 personnes dans 10 pays nous apprend que le temps passé par les enfants dehors est ridiculement bas. Un tiers des enfants au Royaume-Uni passe moins de 30mn par jour dehors. En moyenne un enfant passerait moins de temps dehors qu'un prisonnier.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            C'est vrai que l'aire de jeux du coin de la rue, en tant que parent, elle nous gonfle...\n        ")]), _vm._v(" "), _c('h1', [_vm._v("Du coup...")]), _vm._v(" "), _c('p', [_vm._v("\n            Ce site a pour but de référencer toutes les aires de jeux de France, de nous pousser nous, les parents à sortir plus souvent. Et pourquoi pas, à changer de parc de temps en temps.\n        ")]), _vm._v(" "), _c('h1', [_vm._v("\n            Avec votre aide\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Le fonctionnement de parc-epique est collaboratif.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            La base initiale des aires a été extraite du projet\n            "), _c('a', {
    attrs: {
      "href": "https://www.openstreetmap.org"
    }
  }, [_vm._v("OpenStreetMap")]), _vm._v(", une initiative open source et collaborative de cartographie. Il vous est possible de compléter ces informations en renseignant la liste des équipements présents, en donnant votre avis sur l'aire et en ajoutant des photos.\n            Conformément aux conditions de la licence ODbL, la base de données des aires, enrichie par le site parc-epique, est disponible au "), _c('a', {
    attrs: {
      "href": "https://raw.githubusercontent.com/fchabouis/parc-epique/master/base_repartage_2022_08_22.json"
    }
  }, [_vm._v("téléchargement")]), _vm._v(".\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Le site n'a pas de vocation commerciale. Il est prévu par la suite d'en faire bénéficier les mairies pour leur signaler un équipement défectueux ou leur faire parvenir vos suggestions. En participant vous aidez tout le monde !\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pt-5"
  }, [_c('img', {
    attrs: {
      "src": "static/img/aires_logo_couleur2.png",
      "height": "250px"
    }
  })]), _vm._v(" "), _c('h1', {}, [_vm._v("FAQ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-4 title"
  }, [_vm._v("\n            Comment puis-je participer ?\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vous pouvez participer de manière anonyme ou bien créer un\n            "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("compte")]), _vm._v(", ce qui ne prend que quelques secondes. En étant connectés, vous pourrez ajouter des photos aux aires.\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "pt-4 title"
  }, [_vm._v("\n            Est-il possible d'ajouter une aire ?\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Si une aire n'existe pas sur la carte et que vous souhaitez l'ajouter, faites un clic droit sur la carte (sur ordinateur) ou un appui long (sur mobile et tablette).\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-4 title"
  }, [_vm._v("\n            Qui a fait ça ?\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Francis Chabouis. Je suis un ingénieur et développeur freelance à Paris avec un petit faible pour les cartes.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-4 title"
  }, [_vm._v("\n            Je peux avoir des détails techniques ? Car j'aimerais fait la même chose avec les boulangeries...\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Le code du projet est libre et est publié sur\n            "), _c('a', {
    attrs: {
      "href": "https://github.com/fchabouis/parc-epique",
      "target": "_blank"
    }
  }, [_vm._v("github")]), _vm._v(". J'ai également écrit un article technique qui décrit la démarche et les technologies utilisées sur\n            "), _c('a', {
    attrs: {
      "href": "https://medium.com/cr%C3%A9ation-dune-app-cartographique-avec-firebase-vue/cr%C3%A9ation-dune-app-cartographique-avec-firebase-vue-js-et-leaflet-868e9ea1b958",
      "target": "_blank"
    }
  }, [_vm._v("Medium")]), _vm._v(".\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-4 title"
  }, [_vm._v("\n            Un contact ?\n        ")]), _vm._v("\n        Pour me contacter, utilisez la page\n        "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/ParcEpique/",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(".\n        "), _c('p')]), _vm._v(" "), _c('v-footer', {
    staticClass: "pa-3"
  }, [_c('v-container', {
    staticClass: "text-xs-center",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "fb-share-button",
    attrs: {
      "data-href": "https://parc-epique.fr",
      "data-layout": "button_count",
      "data-size": "small",
      "data-mobile-iframe": "true"
    }
  }, [_c('a', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fparc-epique.fr%2F&src=sdkpreparse"
    }
  }, [_vm._v("Partager")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.askForSignIn),
      callback: function($$v) {
        _vm.askForSignIn = $$v
      },
      expression: "askForSignIn"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Petite question 🙈")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('p', [_vm._v("\n            Votre contribution en tant qu'\n            "), _c('strong', [_vm._v("utilisateur anonyme")]), _vm._v(" est enregistrée. Merci !\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Ça vous dit de vous\n            "), _c('strong', [_vm._v("enregistrer")]), _vm._v(" pour que vos contributions portent votre nom ?\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            C'est trèèès rapide 🚀\n          ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Oui")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.askForSignIn = false
      }
    }
  }, [_vm._v("non")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogAddArea),
      callback: function($$v) {
        _vm.dialogAddArea = $$v
      },
      expression: "dialogAddArea"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Ajouter une aire")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n            Vous souhaitez ajouter une aire de jeux ? C'est ici que ça se passe.\n          ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n            Un marqueur va apparaître sur la carte. Faites le glisser précisement jusqu'au bon endroit, puis cliquez dessus pour confirmer.\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Ok !")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogAddArea = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogConfirmArea),
      callback: function($$v) {
        _vm.dialogConfirmArea = $$v
      },
      expression: "dialogConfirmArea"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Enregister la nouvelle aire ?")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n            Vous êtes sur le point d'ajouter une nouvelle aire de jeux à cet endroit. Elle sera visible par tout le monde.\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.authenticateAndCallback(_vm.pushArea)
      }
    }
  }, [_vm._v("Oui, je le veux")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Non ! La supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogConfirmArea = false
      }
    }
  }, [_vm._v("Revenir à la carte")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogEditArea),
      callback: function($$v) {
        _vm.dialogEditArea = $$v
      },
      expression: "dialogEditArea"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogEditArea = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Ajouter des détails à l'aire")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('EditArea', {
    attrs: {
      "dialogEditArea": _vm.dialogEditArea,
      "equipmentsList": _vm.equipmentsList,
      "uid": _vm.uid,
      "connected": _vm.connected,
      "areaId": _vm.areaId,
      "openAtNightP": _vm.openAtNight,
      "freeAreaP": _vm.freeArea
    },
    on: {
      "editSuccess": _vm.editSuccessActions,
      "askForSignInMsg": function($event) {
        _vm.askForSignIn = true
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogAddComment),
      callback: function($$v) {
        _vm.dialogAddComment = $$v
      },
      expression: "dialogAddComment"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogAddComment = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Ajouter un avis")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h2', [_vm._v("\n                Cadre\n              ")]), _vm._v(" "), _c('star-rating', {
    attrs: {
      "inline": "",
      "star-size": 40,
      "increment": 0.5,
      "show-rating": false,
      "active-color": _vm.tertiary
    },
    model: {
      value: (_vm.ratingSurroundings),
      callback: function($$v) {
        _vm.ratingSurroundings = $$v
      },
      expression: "ratingSurroundings"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h2', [_vm._v("\n                Équipement\n              ")]), _vm._v(" "), _c('star-rating', {
    attrs: {
      "inline": "",
      "star-size": 40,
      "increment": 0.5,
      "show-rating": false,
      "active-color": _vm.tertiary
    },
    model: {
      value: (_vm.ratingEquipment),
      callback: function($$v) {
        _vm.ratingEquipment = $$v
      },
      expression: "ratingEquipment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-5"
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "Commentaire",
      "hint": "Dites ici ce que vous avez pensé de l'aire, donnez éventuellement des infos pratiques..."
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.sendingRating,
      "disabled": _vm.sendingRating,
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.authenticateAndCallback(_vm.sendRating)
      }
    }
  }, [_vm._v("Publier")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "id": "bottomSheet",
      "inset": "",
      "hide-overlay": "",
      "persistent": ""
    },
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-card', {
    staticStyle: {
      "height": "100%",
      "overflow": "scroll"
    }
  }, [_c('v-card-text', [
    [_c('v-btn', {
      attrs: {
        "fab": "",
        "flat": "",
        "color": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.sheet = false
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "text-xs-center": ""
      }
    }, [(_vm.dist) ? _c('div', {
      staticClass: "pb-3"
    }, [_c('h3', [_vm._v("Aire de jeux à " + _vm._s(_vm.dist) + " "), _c('v-icon', [_vm._v("directions_walk")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.googleMapDirections,
        "target": "_blank"
      }
    }, [_vm._v("Itinéraire")])], 1)]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "pt-3"
    }), _vm._v(" "), (_vm.averageRatingSurroundings || _vm.averageRatingEquipment) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('h3', [_vm._v("\n                  Cadre\n                ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "inline": "",
        "read-only": "",
        "star-size": 30,
        "increment": 0.1,
        "show-rating": false,
        "active-color": _vm.tertiary
      },
      model: {
        value: (_vm.averageRatingSurroundings),
        callback: function($$v) {
          _vm.averageRatingSurroundings = $$v
        },
        expression: "averageRatingSurroundings"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('h3', [_vm._v("\n                  Équipement\n                ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "inline": "",
        "read-only": "",
        "star-size": 30,
        "increment": 0.1,
        "show-rating": false,
        "active-color": _vm.tertiary
      },
      model: {
        value: (_vm.averageRatingEquipment),
        callback: function($$v) {
          _vm.averageRatingEquipment = $$v
        },
        expression: "averageRatingEquipment"
      }
    })], 1)], 1) : _c('div', [_c('span', {
      staticClass: "font-italic"
    }, [_vm._v("Pas encore de note, soyez le premier à rédiger un avis !")])])], 1), _vm._v(" "), _c('v-container', _vm._l((_vm.comments), function(c, i) {
      return _c('div', {
        key: i
      }, [_c('div', {
        staticClass: "pt-3"
      }, [_c('p', [_vm._v("\n                  " + _vm._s(c.displayName) + ", le " + _vm._s(_vm.getDateFromTimestamp(c.timestamp))), _c('br'), _vm._v(" Cadre\n                  "), _c('star-rating', {
        attrs: {
          "inline": "",
          "read-only": "",
          "star-size": 15,
          "increment": 0.5,
          "show-rating": false,
          "active-color": _vm.tertiary
        },
        model: {
          value: (c.ratingSurroundings),
          callback: function($$v) {
            _vm.$set(c, "ratingSurroundings", $$v)
          },
          expression: "c.ratingSurroundings"
        }
      }), _vm._v("\n                  Équipement\n                  "), _c('star-rating', {
        attrs: {
          "inline": "",
          "read-only": "",
          "star-size": 15,
          "increment": 0.5,
          "show-rating": false,
          "active-color": _vm.tertiary
        },
        model: {
          value: (c.ratingEquipment),
          callback: function($$v) {
            _vm.$set(c, "ratingEquipment", $$v)
          },
          expression: "c.ratingEquipment"
        }
      }), _vm._v(" "), _c('br'), _vm._v(" "), (c.comment) ? _c('span', [_vm._v("\"" + _vm._s(c.comment) + "\"")]) : _vm._e()], 1)])])
    }), 0), _vm._v(" "), _c('v-container', [_c('div', {
      staticClass: "text-xs-center"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogAddComment = true
        }
      }
    }, [_vm._v("Rédiger un avis")]), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "text-xs-center": ""
      }
    }, [_c('div', {
      staticClass: "pt-3"
    }), _vm._v(" "), (_vm.freeArea === undefined && _vm.openAtNight === undefined && _vm.equipmentsList.length === 0) ? _c('div', {
      staticClass: "font-italic"
    }, [_vm._v("\n              La description de cette aire est inconnue pour le moment. A vous de jouer !"), _c('br')]) : _c('div', [(_vm.freeArea != undefined) ? _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n                  " + _vm._s(_vm.freeArea ? 'Gratuite' : 'Payante') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.openAtNight != undefined) ? _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n                  " + _vm._s(_vm.openAtNight ? 'Ouverte la nuit' : 'Fermée la nuit') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.equipmentsList), function(equipment) {
      return _c('v-chip', {
        attrs: {
          "color": "primary",
          "text-color": "black"
        }
      }, [_vm._v(_vm._s(equipment))])
    }), _vm._v(" "), _c('v-spacer')], 2)]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogEditArea = true
        }
      }
    }, [_vm._v("Suggérer une modification")]), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": true
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.pictures), function(pic, i) {
      return _c('v-flex', {
        key: i,
        attrs: {
          "xs12": "",
          "md4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('v-img', [_c('a', {
        attrs: {
          "href": pic.src,
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "src": pic.thumb
        }
      })])])], 1)], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "accept": "image/*",
        "id": "cameraInput"
      }
    }), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.authenticateAndCallback(_vm.takeAPhoto)
        }
      }
    }, [_vm._v("\n                    Ajouter une photo\n                    "), _c('v-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _vm._l((Object.keys(_vm.uploadProgress)), function(ts, progress) {
      return _c('div', [(_vm.uploadProgress[ts]) ? _c('v-progress-linear', {
        attrs: {
          "color": "primary",
          "value": _vm.uploadProgress[ts]
        }
      }) : _vm._e()], 1)
    })], 2)], 1)]
  ], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-snackbar', {
    attrs: {
      "app": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Bienvenue " + _vm._s(_vm.displayName) + " "), _c('span', {
    staticClass: "display-1"
  }, [_vm._v("🤘")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [(_vm.connected) ? _c('div', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    on: {
      "click": _vm.home
    }
  }, [_vm._v(_vm._s(_vm.displayName))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.signout()
      }
    }
  }, [_vm._v("Se déconnecter")])], 1)], 1)], 1) : _c('div', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('router-link', {
    key: _vm.$route.fullPath,
    attrs: {
      "to": "/login"
    }
  }, [_c('v-list-tile-title', [_vm._v("Créer un compte / se connecter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("map")])], 1), _vm._v(" "), _c('v-list-tile-content', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.mapStyle === 'map') ? _c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.mapStyle = 'satelite'
      }
    }
  }, [_vm._v("Passer en vue satellite")]) : _c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.mapStyle = 'map'
      }
    }
  }, [_vm._v("Passer en vue carte")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("question_answer")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('router-link', {
    attrs: {
      "to": "/apropos"
    }
  }, [_c('v-list-tile-title', [_vm._v("A propos & aide ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "background": "url('static/img/paysage.png') bottom no-repeat",
      "background-size": "contain"
    },
    attrs: {
      "dense": "",
      "dark": "",
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "toolbarTitle"
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "app": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.welcomeDialog),
      callback: function($$v) {
        _vm.welcomeDialog = $$v
      },
      expression: "welcomeDialog"
    }
  }, [_c('v-card', [_c('v-img', {
    attrs: {
      "src": "/static/img/aire-de-jeux.jpg",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Bienvenue sur Parc Épique !")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v("Une carte\n            "), _c('span', {
    staticClass: "strong"
  }, [_vm._v("collaborative")]), _vm._v(" de toutes les aires de jeux pour enfants de France.\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.welcomeDialog = false
      }
    }
  }, [_vm._v("C'est parti 🚀")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Ne plus montrer",
      "color": "primary"
    },
    model: {
      value: (_vm.dontShowAnyMore),
      callback: function($$v) {
        _vm.dontShowAnyMore = $$v
      },
      expression: "dontShowAnyMore"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-content', [_c('router-view', {
    attrs: {
      "map-style": _vm.maps[_vm.mapStyle]
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "color": "orange",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-container', [_c('h1', {
    staticClass: "pt-5 red--text",
    attrs: {
      "color": "error"
    }
  }, [_vm._v("Gestion de la base")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.DeleteAreasEnriched
    }
  }, [_vm._v("Supprimer les aires enrichies")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.copyingAreas
    },
    on: {
      "click": _vm.copyAires
    }
  }, [_vm._v("Copier les aires")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.copyComments
    }
  }, [_vm._v("Copier les commentaires")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.downloadDB
    }
  }, [_vm._v("Créer dump base")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h2', [_vm._v("Parc Épique")]), _vm._v(" "), _c('p', [_vm._v("Pour participer, créez un compte. Cela prend environ 30 secondes.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(168);
module.exports = __webpack_require__(167);


/***/ })

},[464]);


// WEBPACK FOOTER //
// static/js/app.117ba02aa6435c6e9ec5.js